import { render, staticRenderFns } from "./ForensicsLog.vue?vue&type=template&id=25d0fab2"
import script from "./ForensicsLog.vue?vue&type=script&lang=js"
export * from "./ForensicsLog.vue?vue&type=script&lang=js"
import style0 from "./ForensicsLog.vue?vue&type=style&index=0&id=25d0fab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports